// src/components/home/Navbar.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';
import Logo from '../../assets/imgs/Logo.png';
import { FaBars, FaTimes, FaWhatsapp } from 'react-icons/fa'; // Import FaWhatsapp

const Navbar = ({setIsRegisterOpen,setIsPopupVisible}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  // Treat Sparklio, Feedesk and Products routes as the "pricing" view so the navbar
  // switches to the compact/register variant used on product pages.
  const isPricingPage = ["/products", "/feedesk", "/sparklio"].includes(location.pathname);

  const whatsappNumber = '917200702908'; // Replace with your WhatsApp number
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  /* CLOSE DROPDOWN ON OUTSIDE TOUCH / CLICK */
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsContactOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  return (
    <nav className={styles.navbar}>
      <div className={`${styles.logoimg} ${isPricingPage ? styles.logoLeft : ""}`}>
        <img src={Logo} className={styles.logo} alt="bsapark logo" />
      </div>


      <div className={styles.menuIcon} onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      <ul className={`${styles.navLinks} ${isOpen ? styles.active : ''}`}>
        <li><a href="/" onClick={toggleMenu}>Home</a></li>

        {!isPricingPage && (
          <>
            <li><a href="/courses" onClick={toggleMenu}>Courses</a></li>
            <li><a href="/corporate-training" onClick={toggleMenu}>Corporate Training</a></li>
          </>
        )}

        {/* PRODUCT DROPDOWN */}
        <li
          ref={dropdownRef}
          className={styles.dropdown}
        >
          <a
            className={styles.dropdownLink}
            onClick={() => setIsContactOpen(!isContactOpen)}
          >
            Product
          </a>

          {isContactOpen && (
            <ul className={styles.dropdownMenu}>
               <li>
                <a className={styles.ddLink}
                  href="/sparklio"
                  onClick={() => {
                    setIsContactOpen(false);
                    toggleMenu();
                  }}
                >
                  Sparklio 
                </a>
              </li>
              <li>
                
                 <a className={styles.ddLink}
                  href="/feedesk"
                  onClick={() => {
                    setIsContactOpen(false);
                    toggleMenu();
                  }}
                >
                  Feedesk
                </a>
              </li>
              
              {/* <li>
                <a
                  href="/simple-crm"
                  onClick={() => {
                    setIsContactOpen(false);
                    toggleMenu();
                  }}
                >
                  Simple CRM
                </a>
              </li> */}
            </ul>
          )}
        </li>

        <li><a href="/about" onClick={toggleMenu}>About</a></li>
        <li><a href="/contact" onClick={toggleMenu}>Contact</a></li>
        {/* New WhatsApp Icon */}
        <li>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.whatsappIconLink}
            aria-label="Chat with us on WhatsApp"
            onClick={toggleMenu}
          >
            <FaWhatsapp className={styles.whatsappIcon} />
          </a>
        </li>
        {!isPricingPage && (
          <>
            <li>
              <button className={styles.ctaButton} 
              onClick={() => {setIsPopupVisible(true); toggleMenu();}}
              >
                Enroll Now
              </button>
            </li>

            <li>
              <button
                className={styles.ctaButton}
                onClick={() => {
                  window.open(
                    "https://onelogin.bsparksoftwaretechnologies.com/",
                    "_blank"
                  );
                  toggleMenu();
                }}
              >
                SignIn
              </button>
            </li>
          </>
        )}
        {isPricingPage && (
          <li>
            <button
              className={styles.ctaButton}
              onClick={() => {
                setIsRegisterOpen(true);   // ✅ ONLY REGISTER
                toggleMenu();
              }}
            >
              Register
            </button>
          </li>
        )}

        
      </ul>
    </nav>
  );
};

export default Navbar;


// // src/components/home/Navbar.jsx
// import React, { useState } from 'react';
// import styles from './Navbar.module.css';
// import Logo from '../../assets/imgs/Logo.png';
// import { FaBars, FaTimes, FaWhatsapp } from 'react-icons/fa'; // Import FaWhatsapp

// const Navbar = ({setIsPopupVisible}) => {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => setIsOpen(!isOpen);

//   const whatsappNumber = '917200702908'; // Replace with your WhatsApp number
//   const whatsappUrl = `https://wa.me/${whatsappNumber}`;

//   return (
//     <nav className={styles.navbar}>
//       <div className={styles.logoimg}>
//         <img src={Logo} className={styles.logo} alt="bsapark logo" />
//       </div>

//       <div className={styles.menuIcon} onClick={toggleMenu}>
//         {isOpen ? <FaTimes /> : <FaBars />}
//       </div>

//       <ul className={`${styles.navLinks} ${isOpen ? styles.active : ''}`}>
//         <li><a href="/" onClick={toggleMenu}>Home</a></li>
//         <li><a href="/courses" onClick={toggleMenu}>Courses</a></li>
//         <li><a href="/corporate-training" onClick={toggleMenu}>Corporate Training</a></li>
//         <li><a href="/projects" onClick={toggleMenu}>Products</a></li>
//         <li><a href="/about" onClick={toggleMenu}>About</a></li>
//         <li><a href="/contact" onClick={toggleMenu}>Contact</a></li>
//         {/* New WhatsApp Icon */}
//         <li>
//           <a
//             href={whatsappUrl}
//             target="_blank"
//             rel="noopener noreferrer"
//             className={styles.whatsappIconLink}
//             aria-label="Chat with us on WhatsApp"
//             onClick={toggleMenu}
//           >
//             <FaWhatsapp className={styles.whatsappIcon} />
//           </a>
         
//         </li>
//          <li><button className={styles.ctaButton} onClick={() => setIsPopupVisible(true)}>Enroll Now</button></li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;